module.exports = __webpack_public_path__ + "img/placard.5def7c98.png";